import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import LoadingPopup from "../helpers/loading_component.js";
import { secretKey } from "../.././data";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const MySwal = withReactContent(Swal2);

const StatisticsLeads = (props) => {
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState([]);
  const [source, setSource] = useState([]);

  const createExcelStatus = () => {
    var tab = [];
    tab.push(["Lp.", "Rodzaj", "Liczba", "% udziału"]);
    status.map((el2, index) => {
      tab.push([
        index + 1,
        el2.status,
        props.leads.filter((el) => el.status === el2.status).length,
        (
          (props.leads.filter((el) => el.status === el2.status).length /
            props.leads.length) *
          100
        ).toFixed(0) + "%",
      ]);
    });
    return tab;
  };

  const exportToExcelStatus = (e) => {
    const worksheet = XLSX.utils.json_to_sheet(createExcelStatus());
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Dane");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "dane.xlsx");
  };

  const createExcelSource = () => {
    var tab = [];
    tab.push(["Lp.", "Źródło", "Liczba", "% udziału"]);
    source.map((el2, index) => {
      tab.push([
        index + 1,
        el2.name,
        props.leads.filter((el) =>
          props.user.salesSuperAdmin === "1"
            ? el.realSource === el2.name
            : el.source === el2.name
        ).length,
        (
          (props.leads.filter((el) =>
            props.user.salesSuperAdmin === "1"
              ? el.realSource === el2.name
              : el.source === el2.name
          ).length /
            props.leads.length) *
          100
        ).toFixed(0) + "%",
      ]);
    });
    return tab;
  };

  const exportToExcelSource = (e) => {
    const worksheet = XLSX.utils.json_to_sheet(createExcelSource());
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Dane");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "dane.xlsx");
  };

  const createExcelType = () => {
    var tab = [];
    tab.push(["Lp.", "Rodzaj", "Liczba", "% udziału"]);
    tab.push([
      "1",
      "CHF",
      props.leads.filter((el) => el.type === "CHF").length,
      (
        (props.leads.filter((el) => el.type === "CHF").length /
          props.leads.length) *
        100
      ).toFixed(0) + "%",
    ]);

    tab.push([
      "2",
      "EURO",
      props.leads.filter((el) => el.type === "EURO").length,
      (
        (props.leads.filter((el) => el.type === "EURO").length /
          props.leads.length) *
        100
      ).toFixed(0) + "%",
    ]);

    tab.push([
      "3",
      "USD",
      props.leads.filter((el) => el.type === "USD").length,
      (
        (props.leads.filter((el) => el.type === "USD").length /
          props.leads.length) *
        100
      ).toFixed(0) + "%",
    ]);

    tab.push([
      "4",
      "SKD",
      props.leads.filter((el) => el.type === "SKD").length,
      (
        (props.leads.filter((el) => el.type === "SKD").length /
          props.leads.length) *
        100
      ).toFixed(0) + "%",
    ]);

    tab.push([
      "5",
      "WIBOR",
      props.leads.filter((el) => el.type === "WIBOR").length,
      (
        (props.leads.filter((el) => el.type === "WIBOR").length /
          props.leads.length) *
        100
      ).toFixed(0) + "%",
    ]);

    return tab;
  };

  const exportToExcelType = (e) => {
    const worksheet = XLSX.utils.json_to_sheet(createExcelType());
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Dane");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "dane.xlsx");
  };

  const fetchLeadsStatus = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getSellStatus", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setStatus(data);
        fetchLeadsSource();
      })
      .catch((error) => {});
  };

  const fetchLeadsSource = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getLeadSource", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setSource(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    fetchLeadsStatus();
  };

  useEffect(() => {
    getData();
  }, []);

  const statusData = (
    <>
      <div
        style={{
          width: "50%",
          display: "flex",
          gap: "20px",
          alignItems: "center",
        }}
      >
        <p style={{ fontWeight: "600", fontSize: "1.5vw" }}>
          STATUSY KONTAKTÓW
        </p>{" "}
        <button
          style={{
            backgroundColor: "#00bdce",
            border: "none",
            color: "white",
            fontWeight: "600",
            borderRadius: "15px",
          }}
          id="clientsFilterButton"
          className="paymentMenuButton"
          onClick={exportToExcelStatus}
        >
          EXPORT
        </button>
      </div>

      <table id="statTable" style={{ width: "50%" }} className="clients_table">
        <tr key={0}>
          <th>Lp.</th>
          <th>Status</th>
          <th>Liczba</th>
          <th>% udziału</th>
        </tr>
        <>
          {status.map((el2, index) => (
            <>
              <tr>
                <td>{index + 1}</td>
                <td>{el2.status}</td>
                <td>
                  {props.leads.filter((el) => el.status === el2.status).length}
                </td>
                <td>
                  {(
                    (props.leads.filter((el) => el.status === el2.status)
                      .length /
                      props.leads.length) *
                    100
                  ).toFixed(0)}
                  %
                </td>
              </tr>
            </>
          ))}
        </>
      </table>
      <p style={{ fontSize: "0.8vw" }}>Suma kontaktów: {props.leads.length}</p>
    </>
  );

  const sourceData = (
    <>
      <div
        style={{
          width: "50%",
          display: "flex",
          gap: "20px",
          alignItems: "center",
        }}
      >
        <p style={{ fontWeight: "600", fontSize: "1.5vw" }}>ŹRÓDŁA KONTAKTÓW</p>{" "}
        <button
          style={{
            backgroundColor: "#00bdce",
            border: "none",
            color: "white",
            fontWeight: "600",
            borderRadius: "15px",
          }}
          id="clientsFilterButton"
          className="paymentMenuButton"
          onClick={exportToExcelSource}
        >
          EXPORT
        </button>
      </div>

      <table id="statTable" style={{ width: "50%" }} className="clients_table">
        <tr key={0}>
          <th>Lp.</th>
          <th>Źródło</th>
          <th>Liczba</th>
          <th>% udziału</th>
        </tr>
        <>
          {source.map((el2, index) => (
            <>
              <tr>
                <td>{index + 1}</td>
                <td>{el2.name}</td>
                <td>
                  {
                    props.leads.filter((el) =>
                      props.user.salesSuperAdmin === "1"
                        ? el.realSource === el2.name
                        : el.source === el2.name
                    ).length
                  }
                </td>
                <td>
                  {(
                    (props.leads.filter((el) =>
                      props.user.salesSuperAdmin === "1"
                        ? el.realSource === el2.name
                        : el.source === el2.name
                    ).length /
                      props.leads.length) *
                    100
                  ).toFixed(0)}
                  %
                </td>
              </tr>
            </>
          ))}
        </>
      </table>
      <p style={{ fontSize: "0.8vw" }}>Suma kontaktów: {props.leads.length}</p>
    </>
  );

  const typeData = (
    <>
      <div
        style={{
          width: "50%",
          display: "flex",
          gap: "20px",
          alignItems: "center",
        }}
      >
        <p style={{ fontWeight: "600", fontSize: "1.5vw" }}>
          RODZAJE KONTAKTÓW
        </p>{" "}
        <button
          style={{
            backgroundColor: "#00bdce",
            border: "none",
            color: "white",
            fontWeight: "600",
            borderRadius: "15px",
          }}
          id="clientsFilterButton"
          className="paymentMenuButton"
          onClick={exportToExcelType}
        >
          EXPORT
        </button>
      </div>

      <table id="statTable" style={{ width: "50%" }} className="clients_table">
        <tr key={0}>
          <th>Lp.</th>
          <th>Rodzaj</th>
          <th>Liczba</th>
          <th>% udziału</th>
        </tr>
        <tr>
          <td>1</td>
          <td>CHF</td>
          <td>{props.leads.filter((el) => el.type === "CHF").length}</td>
          <td>
            {(
              (props.leads.filter((el) => el.type === "CHF").length /
                props.leads.length) *
              100
            ).toFixed(0)}
            %
          </td>
        </tr>
        <tr>
          <td>2</td>
          <td>EURO</td>
          <td>{props.leads.filter((el) => el.type === "EURO").length}</td>
          <td>
            {(
              (props.leads.filter((el) => el.type === "EURO").length /
                props.leads.length) *
              100
            ).toFixed(0)}
            %
          </td>
        </tr>
        <tr>
          <td>3</td>
          <td>USD</td>
          <td>{props.leads.filter((el) => el.type === "USD").length}</td>
          <td>
            {(
              (props.leads.filter((el) => el.type === "USD").length /
                props.leads.length) *
              100
            ).toFixed(0)}
            %
          </td>
        </tr>
        <tr>
          <td>3</td>
          <td>SKD</td>
          <td>{props.leads.filter((el) => el.type === "SKD").length}</td>
          <td>
            {(
              (props.leads.filter((el) => el.type === "SKD").length /
                props.leads.length) *
              100
            ).toFixed(0)}
            %
          </td>
        </tr>
        <tr>
          <td>4</td>
          <td>WIBOR</td>
          <td>{props.leads.filter((el) => el.type === "WIBOR").length}</td>
          <td>
            {(
              (props.leads.filter((el) => el.type === "WIBOR").length /
                props.leads.length) *
              100
            ).toFixed(0)}
            %
          </td>
        </tr>
      </table>
      <p style={{ fontSize: "0.8vw" }}>Suma kontaktów: {props.leads.length}</p>
    </>
  );

  return (
    <div className="mainContainerAddClient">
      {loading ? (
        <LoadingPopup />
      ) : (
        <>
          <div className="closeBox">
            <button className="closeClientButton" onClick={props.close}>
              X
            </button>
          </div>
          {statusData}
          {sourceData}
          {typeData}
        </>
      )}
    </div>
  );
};

export default StatisticsLeads;
